// extracted by mini-css-extract-plugin
export default {"input":"MyInputForm_input__otIq8","error":"MyInputForm_error__Z+t37","inputWrapper":"MyInputForm_inputWrapper__DB66L"};